import React from "react";
import warning from "../../../../Assets/warning.svg";

const DeletePopup = ({ activeCategoryName, onDelete, onCancel }) => {
  return (  
    <div className="delete-popup">
      <div className="delete-popup-content">
        <div className="warning-icon">
          <img src={warning} alt="warning" />
        </div>
        <p  style={{fontSize:"15px"}}> Are you sure you want to delete all items from <strong>{activeCategoryName}?</strong></p>
        <div className="delete-button">
          <button onClick={onDelete} className="confirm-button">
            Yes
          </button>
          <button onClick={onCancel} className="cancel-button">
            No
          </button> 
        </div>
      </div>
    </div>
  );
};

export default DeletePopup;

